/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FormSectionResponse } from './FormSectionResponse';
import {
    FormSectionResponseFromJSON,
    FormSectionResponseFromJSONTyped,
    FormSectionResponseToJSON,
    FormSectionResponseToJSONTyped,
} from './FormSectionResponse';

/**
 * 
 * @export
 * @interface FormGroupResponse
 */
export interface FormGroupResponse {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    areaId?: string;
    /**
     * 
     */
    title?: string;
    /**
     * 
     */
    description?: string;
    /**
     * 
     */
    order?: number;
    /**
     * 
     */
    sections?: Array<FormSectionResponse>;
}

/**
 * Check if a given object implements the FormGroupResponse interface.
 */
export function instanceOfFormGroupResponse(value: object): value is FormGroupResponse {
    return true;
}

export function FormGroupResponseFromJSON(json: any): FormGroupResponse {
    return FormGroupResponseFromJSONTyped(json, false);
}

export function FormGroupResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormGroupResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'areaId': json['areaId'] == null ? undefined : json['areaId'],
        'title': json['title'] == null ? undefined : json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'order': json['order'] == null ? undefined : json['order'],
        'sections': json['sections'] == null ? undefined : ((json['sections'] as Array<any>).map(FormSectionResponseFromJSON)),
    };
}

export function FormGroupResponseToJSON(json: any): FormGroupResponse {
    return FormGroupResponseToJSONTyped(json, false);
}

export function FormGroupResponseToJSONTyped(value?: FormGroupResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'areaId': value['areaId'],
        'title': value['title'],
        'description': value['description'],
        'order': value['order'],
        'sections': value['sections'] == null ? undefined : ((value['sections'] as Array<any>).map(FormSectionResponseToJSON)),
    };
}

